export default __webpack_public_path__ + "static/media/640_dummy2016-haushalthilfe01-de.d480d3bb.png";